/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChannelConfirmRequest
 */
export interface ChannelConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof ChannelConfirmRequest
     */
    token: string;
}

/**
 * Check if a given object implements the ChannelConfirmRequest interface.
 */
export function instanceOfChannelConfirmRequest(value: object): value is ChannelConfirmRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ChannelConfirmRequestFromJSON(json: any): ChannelConfirmRequest {
    return ChannelConfirmRequestFromJSONTyped(json, false);
}

export function ChannelConfirmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelConfirmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ChannelConfirmRequestToJSON(json: any): ChannelConfirmRequest {
    return ChannelConfirmRequestToJSONTyped(json, false);
}

export function ChannelConfirmRequestToJSONTyped(value?: ChannelConfirmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

